import { configureStore } from '@reduxjs/toolkit';

import reducer from './reducer';

export const bootstrapStore = (dataPreload?: any) => {
    const bootstrapState: any = {
        account: { ...dataPreload.user },
        config: { ...dataPreload.config }
    };

    if (dataPreload?.legal?.form?.guardianEmail) {
        bootstrapState.legal = {
            guardianInfo: dataPreload?.legal?.form
        };
    }

    return bootstrapState;
};

export const createStore = (preloadedState?: any) => {
    const bootstrapState = bootstrapStore(preloadedState);
    // @ts-ignore
    const store = configureStore({
        reducer,
        preloadedState: bootstrapState
    });
    return { store };
};
